<template>
  <v-container fluid class="pa-0 ma-0" id="contact">
    <PageHeader> CONTACT US </PageHeader>

    <UnderLinedHeader
      class="mt-4 white"
      :class="!$vuetify.breakpoint.smAndDown ? 'px-16' : 'mx-2'"
    >
      <p
        class="text-center mt-8"
        :class="!$vuetify.breakpoint.smAndDown ? 'px-16' : ''"
      >
        Let Us Help You Find Solutions for Your Business.
      </p>
    </UnderLinedHeader>
    <ContactMap></ContactMap>

   
  </v-container>
</template>

<script>
import PageHeader from "@/components/global/compnentsMixins/PageHeader.vue";
import UnderLinedHeader from "@/components/global/compnentsMixins/UnderLinedHeader.vue";
import ContactMap from "@/components/contact/ContactMap.vue";
export default {

 
  components: { PageHeader, UnderLinedHeader, ContactMap },
};
</script>

<style lang="scss" scoped>
</style>